import { Component } from '@angular/core';
import {
    UilabMatFormFieldModule,
    UilabMatSelectModule,
    UilabMatOptionModule,
} from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface SelectExample {
    readonly variant: 'filled' | 'outlined';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly appearance: 'fill' | 'outline';
}

@Component({
    selector: 'avd-select-examples',
    templateUrl: './select-examples.component.html',
    styleUrls: ['./select-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatFormFieldModule,
        UilabMatSelectModule,
        UilabMatOptionModule,
    ],
})
export class SelectExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/docs/components-form-controls-select--docs`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/select`;

    readonly options = ['Option 1', 'Option 2', 'Option 3'];

    readonly examples: readonly SelectExample[] = [
        {
            variant: 'outlined',
            label: 'Outline Select',
            description:
                'Use the outline appearance to keep a clear visual boundary between the field and surrounding content.',
            htmlSnippet: `<uilab-mat-form-field appearance="outline">
  <uilab-mat-label>Label</uilab-mat-label>
  <uilab-mat-select placeholder="Select an option">
    <uilab-mat-option value="option1">Option 1</uilab-mat-option>
    <uilab-mat-option value="option2">Option 2</uilab-mat-option>
    <uilab-mat-option value="option3">Option 3</uilab-mat-option>
  </uilab-mat-select>
</uilab-mat-form-field>`,
            appearance: 'outline',
        },
        {
            variant: 'filled',
            label: 'Fill Select',
            description:
                'Use the fill appearance to emphasize the input area in dense forms.',
            htmlSnippet: `<uilab-mat-form-field appearance="fill">
  <uilab-mat-label>Label</uilab-mat-label>
  <uilab-mat-select placeholder="Select an option">
    <uilab-mat-option value="option1">Option 1</uilab-mat-option>
    <uilab-mat-option value="option2">Option 2</uilab-mat-option>
    <uilab-mat-option value="option3">Option 3</uilab-mat-option>
  </uilab-mat-select>
</uilab-mat-form-field>`,
            appearance: 'fill',
        },
    ];
}
